import type { AxisResponse } from "models/Dashboard";

type SeriesItem = { name?: string; data: number[] };

// Chuỗi "Trực tuyến"/"Ngoại tuyến" của statistic-home-controller; tìm theo tên, không có thì lấy theo thứ tự.
function pickSeries(series: SeriesItem[], keyword: string, fallbackIndex: number) {
  return series.find((item) => item.name?.toLowerCase().includes(keyword)) ?? series[fallbackIndex];
}

export function summarizeHc(response?: AxisResponse) {
  const series = (Array.isArray(response?.series) ? response?.series : []) as SeriesItem[];
  const online = pickSeries(series, "trực", 0)?.data ?? [];
  const offline = pickSeries(series, "ngoại", 1)?.data ?? [];
  const names = (response?.horizontalAxis ?? []) as unknown as string[];
  const rows = names.map((name, index) => {
    const on = Number(online[index]) || 0;
    const off = Number(offline[index]) || 0;
    return { name, online: on, offline: off, total: on + off };
  });
  const onlineTotal = rows.reduce((sum, row) => sum + row.online, 0);
  const total = rows.reduce((sum, row) => sum + row.total, 0);
  return { rows, online: onlineTotal, offline: total - onlineTotal, total };
}

const OTHER = "Khác";
const UNKNOWN = "Chưa xác định loại";

// Cộng mọi chuỗi theo từng loại, xếp giảm dần; quá TOP loại thì gộp phần đuôi vào "Khác".
export type DeviceTypeRow = { name: string; value: number; isRest?: boolean };

export function rankDeviceTypes(response?: AxisResponse, top = 8): DeviceTypeRow[] {
  const series = (Array.isArray(response?.series) ? response?.series : []) as SeriesItem[];
  const names = (response?.horizontalAxis ?? []) as unknown as string[];
  const rows = names
    .map((name, index) => ({
      name,
      value: series.reduce((sum, item) => sum + (Number(item.data?.[index]) || 0), 0),
    }))
    .filter((row) => row.value > 0)
    .sort((a, b) => b.value - a.value);
  // API có sẵn nhóm "Khác" (loại chưa có trong danh mục): luôn để cuối, gộp chung với phần đuôi, không ra hai dòng "Khác".
  const named = rows.filter((row) => row.name !== OTHER);
  const other = rows.filter((row) => row.name === OTHER).reduce((sum, row) => sum + row.value, 0);
  const fits = named.length + (other > 0 ? 1 : 0) <= top;
  const shown = fits ? named : named.slice(0, top - 1);
  const rest = other + (fits ? 0 : named.slice(top - 1).reduce((sum, row) => sum + row.value, 0));
  // Chỉ có nhóm từ API thì gọi đúng nghĩa; có gộp thêm loại nhỏ thì mới là "Khác".
  const restName = fits ? UNKNOWN : OTHER;
  return rest > 0 ? [...shown, { name: restName, value: rest, isRest: true }] : shown;
}
